import React from "react";
import Navbars from "./Navbar";
import Item1 from "./Item1";
import VideoGallery from "./VideoGallery";
import SocialIcons from "./SocialIcons";
const Portfolio = () => {
  return (
    <>
      <Navbars />
      <Item1 />
      <VideoGallery />
      <SocialIcons />
    </>
  );
};

export default Portfolio;
